import itemStyle from './treemap.breadcrumb.itemStyle'
import emphasis from './treemap.breadcrumb.emphasis'

export default {
  name: "breadcrumb",
  nickname: "面包屑",
  desc: "面包屑，能够显示当前节点的路径。",
  type: "object",
  props: {
    show: {
      name: "show",
      nickname: "显示",
      desc: "是否显示面包屑。",
      value: true,
      defaultValue: true,
      type: "pureValue",
    },
    left: {
      name: "left",
      nickname: "位置左",
      desc: "asdf 组件离容器左侧的距离。",
      value: "center",
      defaultValue: "center",
      type: "pureValue",
    },
    top: {
      name: "top",
      nickname: "位置上",
      desc: "asdf 组件离容器上侧的距离。",
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    right: {
      name: "right",
      nickname: "位置右",
      desc: "asdf 组件离容器右侧的距离。",
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    bottom: {
      name: "bottom",
      nickname: "位置下",
      desc: "asdf 组件离容器下侧的距离。",
      value: 0,
      defaultValue: 0,
    },
    height: {
      name: "height",
      nickname: "高度",
      desc: "面包屑的高度。",
      value: 22,
      defaultValue: 22,
      type: "pureValue",
    },
    emptyItemWidth: {
      name: "emptyItemWidth",
      nickname: "为空时最小宽度",
      desc: "当面包屑没有内容时候，设个最小宽度。",
      value: 25,
      defaultValue: 25,
      type: "pureValue",
    },
    itemStyle,
    emphasis,
  },
}
